import { definePage, type PluginWebManifest } from '@reflex/plugin-api/web';

/**
 * Chief's web contributions, split from `src/index.ts` so the browser
 * bundle never imports the plugin definition — `index.ts` pulls in
 * `node:path` and the server route stack, which cannot ship to the client.
 * `src/web/register.ts` and the host web build read this file only.
 */
const page = definePage({
  path: '/chief',
  label: 'Chief',
  icon: 'Shield',
  group: 'misc',
  componentPath: '@reflex/plugin-chief/web/ChiefPage',
  maturityStage: 'preview',
  description:
    'A dockable copilot that drives Reflex from one chat window: it steers this browser tab, watches your agent threads, and proposes agent launches you approve.',
});

export const chiefWeb: PluginWebManifest = {
  ...page.web,
  globalUiElements: [
    {
      id: 'chief-dock',
      componentPath: '@reflex/plugin-chief/web/ChiefHost',
    },
  ],
  // The way in: a visor icon in the nav's utility row, beside Inbox. The
  // panel it opens is the `chief-dock` element above; the two mount
  // separately and share state through `web/chief-store`.
  navUtilityElements: [
    {
      id: 'chief-launcher',
      componentPath: '@reflex/plugin-chief/web/ChiefNavButton',
    },
  ],
};
